<template>
  <div>
    <div class="min-vh-100">
      <b-row class="no-gutters px-3 px-sm-0">
        <b-col xl="5" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">
            แบทช์คลังสินค้า
            <span
              class="span-tooltip"
              v-b-tooltip.hover.topleft
              :title="tooltip"
            >
              รอบต่อไป
              <b-icon icon="info-circle-fill" class="size-icon" />
            </span>
          </h1>
        </b-col>
        <b-col xl="7" class="text-right d-flex justify-content-end">
          <b-input-group class="panel-input-serach">
            <b-form-input
              id="product-search"
              class="input-serach"
              :placeholder="
                tabCurrentType == 0
                  ? 'ค้นหาหมายเลขชุดแบทช์ / Batch ID'
                  : 'ค้นหาหมายเลขคำสั่งซื้อ / Order ID'
              "
              @keypress="handlePushMessage"
              v-model="filter.batchNo"
            ></b-form-input>
            <b-input-group-prepend>
              <span class="icon-input m-auto pr-2">
                <font-awesome-icon
                  icon="search"
                  title="View"
                  @click="onSubmitFilter"
                />
              </span>
            </b-input-group-prepend>
          </b-input-group>
          <b-dropdown
            id="dropdown-product"
            text="ตัวเลือกเพิ่มเติม"
            class="ml-2 dropdown-option"
          >
            <b-dropdown-item
              @click="goToCreateBatch"
              :disabled="itemsSelected.length > 0"
            >
              สร้าง Batch ใหม่
            </b-dropdown-item>
            <b-dropdown-item
              @click="exportBatch"
              :disabled="itemsSelected.length == 0 || tabCurrentType == 1"
            >
              นำออกข้อมูล Batch Excel
            </b-dropdown-item>
            <b-dropdown-item
              @click="exportOrder"
              :disabled="itemsSelected.length == 0 || tabCurrentType == 0"
            >
              นำออกข้อมูล Order Excel
            </b-dropdown-item>
          </b-dropdown>
          <b-button v-b-toggle.sidebar-filter class="btn-filter ml-2">
            <font-awesome-icon
              icon="filter"
              title="filter-btn"
              class="main-color mr-0 mr-sm-1"
            />
            <span class="d-none d-sm-inline">ตัวกรอง</span>
          </b-button>
        </b-col>
      </b-row>
      <b-sidebar
        v-model="isModal"
        id="sidebar-filter"
        backdrop
        shadow
        backdrop-variant="dark"
        right
        ref="filterSidebar"
        aria-labelledby="sidebar-filter-title"
        no-header
      >
        <template #default="{ hide }">
          <div class="p-3 sidebar-filter-header d-flex justify-content-between">
            <h4 id="sidebar-filter-title" class="m-0">ตัวกรอง</h4>
            <font-awesome-icon
              class="my-auto pointer"
              icon="times-circle"
              color="#FFFFFF"
              @click="hide"
            />
          </div>
          <div class="px-3 py-2">
            <div class="mt-2">
              <b-input-group class="panel-input-serach">
                <b-form-input
                  id="product-search"
                  class="input-serach"
                  placeholder="ค้นหาหมายเลขคำสั่งซื้อ/Batch ID"
                  v-model="filter.batchNo"
                ></b-form-input>
                <b-input-group-prepend>
                  <span class="icon-input m-auto pr-2">
                    <font-awesome-icon icon="search" title="View" />
                  </span>
                </b-input-group-prepend>
              </b-input-group>
            </div>

            <div class="mt-3">
              <div class="font-weight-bold mb-2">วันที่สร้าง</div>
              <div :class="['input-container']">
                <datetime
                  :input-style="styleDatetime"
                  v-model="filter.createDate"
                  placeholder="วว / ดด / ปป"
                  ref="createDate"
                  :max-datetime="maxDatetime"
                >
                </datetime>
                <div
                  class="icon-container text-right"
                  @click="$refs.createDate.isOpen = true"
                >
                  <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
                </div>
              </div>
            </div>

            <!-- <div class="mt-3">
              <div class="font-weight-bold mb-2">ช่องทางการซื้อ</div>
              <b-form-group>
                <b-form-checkbox
                  v-for="(channel, index) in saleChannelConfigList"
                  :key="index"
                  :value="channel.id"
                  class="mb-2"
                  v-model="filter.ChannelId"
                  >{{ channel.name }}</b-form-checkbox
                >
              </b-form-group>
            </div> -->

            <div class="mt-3">
              <div class="font-weight-bold mb-2">แบรนด์</div>
              <b-form-group>
                <b-form-checkbox
                  v-for="(channel, index) in brandIDList"
                  :key="index"
                  :value="channel.id"
                  class="mb-2"
                  v-model="filter.brandID"
                  >{{ channel.name }}</b-form-checkbox
                >
              </b-form-group>
            </div>

            <div class="mt-3">
              <div class="font-weight-bold mb-2">ช่องทางการจัดส่ง</div>
              <b-form-group>
                <b-form-checkbox
                  v-for="(delivery, index) in deliveryChannalConfigList"
                  :key="index"
                  :value="delivery.id"
                  class="mb-2"
                  v-model="filter.ShppingId"
                  >{{ delivery.name }}</b-form-checkbox
                >
              </b-form-group>
            </div>
            <div class="mt-3">
              <div class="font-weight-bold mb-2">สีรายการสั่งซื้อ</div>
              <b-form-group>
                <b-form-checkbox
                  v-for="(color, index) in datetimeColorConfigList"
                  :key="index"
                  :value="color.id"
                  class="mb-2"
                  v-model="filter.PaymentTimeId"
                  ><font-awesome-icon
                    icon="circle"
                    :class="[
                      'flag',
                      color.id === 3
                        ? 'text-danger'
                        : color.id === 1
                        ? 'text-success'
                        : 'text-warning',
                    ]"
                  />
                  {{ color.name }}</b-form-checkbox
                >
              </b-form-group>
            </div>
          </div>
        </template>

        <template #footer>
          <div
            class="d-flex justify-content-between shadow align-items-center border-top"
          >
            <div class="w-100">
              <b-button
                block
                size="lg"
                variant="light"
                class="text-dark w-100 border-radius-0 btn-clear-filter"
                @click="clearFilter"
                >ล้างตัวกรอง</b-button
              >
            </div>
            <div class="w-100">
              <b-button
                block
                size="lg"
                variant="light"
                class="text-body btn-main w-100 border-radius-0"
                @click="onSubmitFilter"
              >
                ยืนยัน
              </b-button>
            </div>
          </div>
        </template>
      </b-sidebar>

      <div v-show="isCountBatch">
        <b-row class="no-gutters px-3 px-sm-0 mt-2" v-if="!isBusy">
          <b-col class="overflow-auto">
            <b-tabs class="mt-2 batch-tabs" v-model="filter.statusId">
              <b-tab
                v-for="(item, index) in statusList"
                :key="index"
                :title="`${item.name} (${item.count})`"
                @click="selectTab(item)"
              >
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>

        <div class="bg-white py-3 py-sm-0">
          <b-row class="no-gutters px-3 px-sm-0">
            <b-col class="overflow-auto">
              <b-tabs pills content-class="d-none" class="m-2">
                <b-tab title="ชุดแบทช์" @click="selectTabType(0)"></b-tab>
                <b-tab
                  v-if="filter.statusId < 6"
                  title="รายการสั่งซื้อ"
                  @click="selectTabType(1)"
                ></b-tab>
              </b-tabs>
            </b-col>
          </b-row>

          <b-row class="no-gutters px-3 px-sm-0" v-if="!isBusy">
            <b-col>
              <b-table
                responsive
                class="text-center table-list mb-0"
                empty-text="ไม่พบข้อมูล"
                :fields="computedFields"
                :items="computedItems"
                :busy="isBusy"
                show-empty
                striped
              >
                <template v-slot:head(id)="">
                  <b-form-checkbox
                    size="lg"
                    class="ml-3"
                    id="order-time-cb-all"
                    name="orderTimeCbAll"
                    v-model="checkBoxBatch"
                    @change="checkBatchHeader"
                  ></b-form-checkbox>
                </template>
                <template v-slot:cell(id)="data">
                  <b-form-checkbox
                    size="lg"
                    class="ml-3"
                    :value="
                      tabCurrentType == 0 ? data.item.id : data.item.orderId
                    "
                    v-model="itemsSelected"
                  ></b-form-checkbox>
                </template>
                <template v-slot:cell(batchNo)="data">
                  <p class="m-0 text-left" v-if="data.item.batchNo">
                    <span>
                      <font-awesome-icon
                        icon="circle"
                        :class="[
                          'flag',
                          data.item.datetimeColor === 3
                            ? 'text-danger'
                            : data.item.datetimeColor === 1
                            ? 'text-success'
                            : 'text-warning',
                        ]"
                      />
                    </span>
                    <span class="text-nowrap">
                      {{ data.item.batchNo }}
                    </span>
                    <br />
                    <span class="text-grey" v-if="data.item.orderQuantity">
                      ({{ data.item.orderQuantity }} รายการ)
                    </span>
                  </p>
                  <p v-else class="m-0">-</p>
                </template>

                <!-- divide -->

                <template v-slot:head(trackingNo)="">
                  <b-form-checkbox
                    size="lg"
                    class="ml-3"
                    id="order-time-cb-all"
                    name="orderTimeCbAll"
                    v-model="checkBoxOrder"
                    @change="checkBatchHeader"
                  ></b-form-checkbox>
                </template>
                <template v-slot:cell(trackingNo)="data">
                  <b-form-checkbox
                    size="lg"
                    class="ml-3"
                    :value="
                      tabCurrentType == 0 ? data.item.id : data.item.orderId
                    "
                    v-model="itemsSelected"
                  ></b-form-checkbox>
                </template>
                <template v-slot:cell(productQty)="data">
                  <div class="stock-text" v-if="data.item.productQty">
                    <p class="m-0">
                      {{ data.item.productQty | numeral("0,0") }}
                    </p>
                  </div>
                  <div v-else class="stock-text"><p class="m-0">-</p></div>
                </template>
                <template v-slot:cell(systemInvoiceNo)="data">
                  <p class="m-0" v-if="data.item.systemInvoiceNo">
                    {{ data.item.systemInvoiceNo }}
                  </p>
                  <p v-else class="m-0">-</p>
                </template>

                <template v-slot:cell(invoiceNo)="data">
                  <div v-if="data.item.invoiceNo">
                    <p class="m-0">{{ data.item.invoiceNo }}</p>
                    <b-badge
                      v-if="data.item.gwp == 1"
                      pill
                      variant="Info"
                      class="px-3 py-2 GWP mt-1"
                      >GWP</b-badge
                    >
                  </div>
                  <div v-else><p class="m-0">-</p></div>
                </template>

                <template v-slot:cell(receiptNo)="data">
                  <p class="m-0" v-if="data.item.receiptNo">
                    {{ data.item.receiptNo }}
                  </p>
                  <p v-else class="m-0">-</p>
                </template>

                <template v-slot:cell(grandTotal)="data">
                  <p class="m-0 price-text" v-if="data.item.grandTotal">
                    ฿ {{ data.item.grandTotal | numeral("0,0.00") }}
                  </p>
                  <p v-else class="m-0 price-text">-</p>
                </template>

                <template v-slot:cell(paymentType)="data">
                  <p class="m-0" v-if="data.item.paymentType">
                    {{ data.item.paymentType }}
                  </p>
                  <p v-else class="m-0">-</p>
                </template>

                <template v-slot:cell(orderStatus)="data">
                  <p class="m-0" v-if="data.item.orderStatus">
                    {{ data.item.orderStatus }}
                  </p>
                  <p v-else class="m-0">-</p>
                </template>

                <template v-slot:cell(shippingType)="data">
                  <p class="m-0" v-if="data.item.shippingType">
                    {{ data.item.shippingType }}
                  </p>
                  <p v-else class="m-0">-</p>
                </template>
                <template v-slot:cell(salesChannel)="data">
                  <div class="position-relative picture-text">
                    <div
                      v-if="data.item.pictureUrl"
                      class="pictureUrl-square-box b-contain"
                      v-bind:style="{
                        'background-image': 'url(' + data.item.pictureUrl + ')',
                      }"
                    ></div>
                    <div v-else-if="data.item.salesChannel" class="">
                      {{ data.item.salesChannel }}
                    </div>
                    <div v-else class="">-</div>
                  </div>
                </template>

                <template v-slot:cell(display)="data">
                  <div v-if="data.item.display == true" class="">แสดง</div>
                  <div v-else class="">ไม่แสดง</div>
                </template>
                <template v-slot:cell(enabled)="data">
                  <div>
                    <toggle-button
                      class="mt-1 mr-2"
                      v-model="data.item.enabled"
                      :color="{
                        checked: '#27BDA7',
                        unchecked: '#F1F1F1',
                        disabled: '#CCCCCC',
                      }"
                    />
                  </div>
                </template>
                <template v-slot:cell(createdTime)="data">
                  <div class="date-cb table-row" v-if="data.item.createdTime">
                    {{
                      new Date(data.item.createdTime) | moment($formatDateTime)
                    }}
                  </div>
                  <div class="date-cb" v-else><p class="m-0">-</p></div>
                </template>
                <template v-slot:cell(dateOrder)="data">
                  <div class="date-text table-row" v-if="data.item.dateOrder">
                    {{
                      new Date(data.item.dateOrder) | moment($formatDateTime)
                    }}
                  </div>
                  <div class="date-text" v-else><p class="m-0">-</p></div>
                </template>
                <template v-slot:cell(updatedTime)="data">
                  <div class="date-text" v-if="data.item.updatedTime">
                    {{
                      new Date(data.item.updatedTime) | moment($formatDateTime)
                    }}
                  </div>
                  <div class="date-text" v-else>-</div>
                </template>
                <template v-slot:cell(orderId)="data">
                  <b-button variant="link" class="px-1 py-0">
                    <router-link
                      :to="toDetail(data.item)"
                      class="text-purple-1"
                    >
                      <u>ดูรายละเอียด</u>
                    </router-link>
                  </b-button>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center text-black my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="ml-2">Loading...</strong>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row class="no-gutters px-3 px-sm-0" v-if="!isBusy && isCountBatch">
            <b-col
              class="form-inline justify-content-center justify-content-sm-end"
            >
              <div class="d-sm-flex m-3">
                <b-pagination
                  v-model="filter.Skip"
                  :total-rows="rows"
                  :per-page="filter.Take"
                  class="m-md-0 page-item"
                  @change="pagination"
                  align="center"
                ></b-pagination>
              </div>

              <b-form-select
                class="mr-sm-3 select-page"
                v-model="filter.Take"
                @change="hanndleChangePerpage"
                :options="pageOptions"
              ></b-form-select>
            </b-col>
          </b-row>
        </div>
      </div>
      <div v-show="!isCountBatch">
        <div class="text-center text-black my-2 loading-page">
          <div>
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </div>
      </div>
    </div>
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";

import { mapGetters } from "vuex";

export default {
  name: "BatchIndex",
  components: {
    ModalAlertError,
    ModalLoading,
  },
  data() {
    return {
      isModal: false,
      modalMessage: "",
      fieldsBatch: [
        { key: "id", label: "" },
        {
          key: "batchNo",
          label: `หมายเลขชุดแบทช์`,
          class: "w-100px text-nowrap",
        },
        {
          key: "dateOrder",
          label: `วันที่สร้าง`,
          class: "w-100px text-nowrap",
        },
        {
          key: "orderQuantity",
          label: `จำนวนรายการสั่งซื้อ`,
          class: "w-100px",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
          },
        },
        {
          key: "itemQuantity",
          label: `จำนวนสินค้า`,
          class: "w-100px text-nowrap",
        },
        {
          key: "shippingName",
          label: `ช่องทางการจัดส่ง`,
          class: "w-100px text-nowrap",
        },
        {
          key: "sellerShopName",
          label: `ช่องทาง`,
          class: "w-100px text-nowrap",
        },
        {
          key: "statusName",
          label: `สถานะ`,
          class: "w-50px text-nowrap",
        },
        // {
        //   key: "paymentType",
        //   label: `ชื่อพนักงานรับผิดชอบ`,
        //   class: "w-100px",
        //   thStyle: {
        //     "padding-left": "0px !important",
        //     "padding-right": "0px !important",
        //   },
        // },
        // {
        //   key: "shippingType",
        //   label: `อัพเดทล่าสุด`,
        //   class: "w-100px text-nowrap",
        // },
        {
          key: "orderId",
          label: "",
          class: "w-50px text-nowrap",
        },
      ],
      fieldsOrder: [
        { key: "trackingNo", label: "" },
        {
          key: "invoiceNo",
          label: `หมายเลขคำสั่งซื้อ`,
          class: "w-100px text-nowrap",
        },
        {
          key: "receiptNo",
          label: `หมายเลขบิล`,
          class: "w-200 text-nowrap",
        },
        {
          key: "batchNo",
          label: `หมายเลขชุดแบทช์`,
          class: "w-100px text-nowrap",
        },
        {
          key: "totalProduct",
          label: `จำนวนสินค้า`,
          class: "w-100px text-nowrap",
        },
        {
          key: "shipping",
          label: `ช่องทางการจัดส่ง`,
          class: "w-100px text-nowrap",
        },
        {
          key: "sellerShop",
          label: `ช่องทาง`,
          class: "w-100px text-nowrap",
        },
        {
          key: "createdTime",
          label: `วันที่สร้าง`,
          class: "w-100px text-nowrap",
        },
        // {
        //   key: "employeeName",
        //   label: `ชื่อพนักงานรับผิดชอบ`,
        //   class: "w-100px",
        //   thStyle: {
        //     "padding-left": "0px !important",
        //     "padding-right": "0px !important",
        //   },
        // },
        // {
        //   key: "updatedTime",
        //   label: `อัพเดทล่าสุด`,
        //   class: "w-100px text-nowrap",
        // },
        {
          key: "orderId",
          label: "",
          class: "w-50px text-nowrap",
        },
      ],
      itemsBatch: [],
      itemsOrder: [],
      itemsSelected: [],
      statusList: [],
      isBusy: false,
      filter: {
        statusId: 0,
        Search: "",
        batchNo: "",
        CreateDate: "",
        brandID: [],
        ChannelId: [],
        ShppingId: [],
        PaymentTimeId: [],
        Skip: 1,
        Take: 10,
      },
      rows: 0,
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      datetimeColorConfigList: [
        {
          id: 1,
          name: "สีเขียว",
        },
        {
          id: 2,
          name: "สีเหลือง",
        },
        {
          id: 3,
          name: "สีแดง",
        },
      ],
      brandIDList: [],
      saleChannelConfigList: [],
      deliveryChannalConfigList: [],
      tabCurrentType: 0,
      styleDatetime: {
        width: "100%",
        border: "none",
      },
      selectItemAll: false,
      listAllDataId: [],
      sellerIdAll: [],
      shippingIdAll: [],

      // new state
      maxDatetime: null,

      // state tooltip
      tooltip: "",

      // state toggle
      isCountBatch: false,

      checkBoxBatch: false,
      checkBoxOrder: false,
    };
  },
  watch: {
    // itemsSelected: {
    //   handler(val) {
    //     if (this.tabCurrentType == 0) {
    //       this.selectItemAll =
    //         val.length == this.itemsBatch.length ? true : false;
    //     } else {
    //       this.selectItemAll =
    //         val.length == this.itemsOrder.length ? true : false;
    //     }
    //   },
    // },
    "filter.batchNo"(val) {
      this.filter.Search = val;
    },
  },
  computed: {
    ...mapGetters({
      GFilterBatch: "filter/getFilterBatch",
    }),
    computedFields() {
      if (this.tabCurrentType == 0) {
        return this.fieldsBatch;
      } else {
        return this.fieldsOrder;
      }
    },
    computedItems() {
      if (this.tabCurrentType == 0) {
        return this.itemsBatch;
      } else {
        return this.itemsOrder;
      }
    },
  },
  mounted() {
    this.isFilter();
    this.getListByType();
    // this.getBatchStatusList();
    this.getBatchCount();
    this.getFilterList();
    this.setMaxDate();

    this.getTimeBatch();

    // clear filter global
    // this.$store.dispatch('filter/CHANGE_FILTERBATCH',null)
    this.$store.dispatch("filter/CHANGE_FILTERTRACKING", null);
    this.$store.dispatch("filter/CHANGE_FILTERSHIPPING", null);
    this.$store.dispatch("filter/CHANGE_FILTERTRANSPORT", null);
  },
  methods: {
    getTimeBatch() {
      this.axios
        .get(`${this.$baseUrl}/order/timebatch`)
        .then((result) => {
          if (result.result == 1) {
            this.tooltip = result.detail
              .map(
                (x) =>
                  `${x.companyCode} : ${this.$moment(x.nextBatchTime).format(
                    "HH:mm"
                  )}`
              )
              .join(" , ");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    isFilter() {
      if (this.GFilterBatch) {
        this.filter = this.GFilterBatch;
      }
    },
    setMaxDate() {
      let date = new Date();
      this.maxDatetime = date.toISOString();
    },
    toDetail(value) {
      let text = "";

      if (this.tabCurrentType == 0) {
        text = `/batch/details/${value.id}?brandID=${this.$route.query.brandID}`;
      } else {
        text = `/order/details/${value.orderId}?brandID=${this.$route.query.brandID}`;
      }

      return text;
    },
    getBatchList() {
      this.isBusy = true;
      let addIsWeb = { ...this.filter, isWeb: true };

      this.$store.dispatch("filter/CHANGE_FILTERBATCH", addIsWeb);

      this.axios
        .post(`${this.$baseUrl}/Batch/ListBatch`, addIsWeb)
        .then((data) => {
          this.itemsBatch = data.detail;
          this.isBusy = false;

          let count = 0;

          for (let i = 0; i < this.itemsSelected.length; i++) {
            const x = this.itemsSelected[i];

            for (let j = 0; j < this.itemsBatch.length; j++) {
              const y = this.itemsBatch[j];

              if (x == y.id) {
                count++;
                break;
              }
            }
          }

          if (count == this.filter.Take) {
            this.checkBoxBatch = true;
          } else {
            this.checkBoxBatch = false;
          }

          // clear selected
          if (this.tabCurrentType == 1) {
            this.itemsSelected = [];
          }
        });
    },
    getBatchCount() {
      this.isCountBatch = false;

      let addIsWeb = { ...this.filter, isWeb: true };

      this.axios
        .post(`${this.$baseUrl}/Batch/CountBatch`, addIsWeb)
        .then((data) => {
          this.statusList = data.detail;

          let findCount = this.statusList.find((x) => {
            let statusID =
              this.filter.statusId == -1 ? 0 : this.filter.statusId;

            return x.id == statusID;
          });

          this.rows = findCount.count;

          this.isCountBatch = true;
        });
    },

    getOrderList() {
      this.isBusy = true;
      let addIsWeb = { ...this.filter, isWeb: true };

      this.axios
        .post(`${this.$baseUrl}/Batch/OrderDetailList`, addIsWeb)
        .then((data) => {
          this.itemsOrder = data.detail.orders;
          this.rows = data.detail.count;
          this.listAllDataId = data.detail.id;
          this.isBusy = false;

          let count = 0;

          for (let i = 0; i < this.itemsSelected.length; i++) {
            const x = this.itemsSelected[i];

            for (let j = 0; j < this.itemsOrder.length; j++) {
              const y = this.itemsOrder[j];

              if (x == y.orderId) {
                count++;
                break;
              }
            }
          }

          if (count == this.filter.Take) {
            this.checkBoxOrder = true;
          } else {
            this.checkBoxOrder = false;
          }

          // clear selected
          if (this.tabCurrentType == 0) {
            this.itemsSelected = [];
          }
        });
    },
    async getFilterList() {
      let getShippingList = await this.axios.get(
        `${this.$baseUrl}/batch/shipping/list`
      );

      if (getShippingList.result == 1) {
        this.deliveryChannalConfigList = getShippingList.detail;
      }

      let getBrandIDList = await this.axios.get(
        `${this.$baseUrl}/batch/brandList`
      );

      if (getBrandIDList.result == 1) {
        this.brandIDList = getBrandIDList.detail;
      }
    },
    // getFilterList() {
    //   this.sellerIdAll = [];
    //   this.shippingIdAll = [];
    //   // this.axios.get(`${this.$baseUrl}/batch/seller/list`).then((data) => {
    //   // this.saleChannelConfigList = data.detail;
    //   this.axios
    //     .get(`${this.$baseUrl}/batch/shipping/list`)
    //     .then((data) => {
    //       this.deliveryChannalConfigList = data.detail;
    //       this.saleChannelConfigList.forEach((e) => {
    //         this.sellerIdAll.push(e.id);
    //       });
    //       this.deliveryChannalConfigList.forEach((e) => {
    //         this.shippingIdAll.push(e.id);
    //       });
    //       // this.filter.ChannelId = this.sellerIdAll;
    //       // this.filter.ShppingId = this.shippingIdAll;
    //     })
    //     .then(() => {
    //       this.axios
    //         .get(`${this.$baseUrl}/batch/brandList`)
    //         .then((data) => {
    //           this.brandIDList = data.detail;
    //         })
    //         .catch((err) => {
    //           console.log(err);
    //         });
    //     });
    //   // });
    // },
    getListByType() {
      if (this.tabCurrentType == 0) {
        this.getBatchList();
      } else {
        this.getOrderList();
      }
    },
    pagination(Page) {
      this.filter.Skip = Page;
      this.getListByType();
    },
    hanndleChangePerpage(value) {
      this.filter.Skip = 1;
      this.filter.Take = value;
      this.getListByType();
    },
    selectTab(obj) {
      this.getBatchCount();

      let { id, count } = obj;

      this.rows = count;
      this.filter.statusId = id;
      this.filter.Skip = 1;
      this.filter.Take = 10;

      // clear checkbox
      this.checkBoxBatch = false;

      this.getListByType();
      // this.clearFilter();
    },
    selectTabType(tab) {
      this.tabCurrentType = tab;
      this.filter.Skip = 1;
      this.filter.Take = 10;
      this.clearFilter();

      if (tab == 0) {
        let findCount = this.statusList.find(
          (x) => x.id == this.filter.statusId
        );
        this.rows = findCount.count;
      }
    },
    handlePushMessage(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.onSubmitFilter();
      }
    },
    onSubmitFilter() {
      this.isModal = false;

      this.filter.Skip = 1;
      this.filter.Search = this.filter.batchNo;

      this.getListByType();
      this.getBatchCount();

      // this.itemsSelected = [];

      this.$refs.filterSidebar.hide();
    },
    checkBatchHeader(value) {
      let arrSelect = this.computedItems.map((x) => {
        if (x.id) {
          return x.id;
        } else {
          return x.orderId;
        }
      });

      if (value) {
        this.itemsSelected = [...this.itemsSelected, ...arrSelect];

        this.itemsSelected = this.itemsSelected.filter(
          (item, index) => this.itemsSelected.indexOf(item) === index
        );
      } else {
        this.itemsSelected = this.itemsSelected.filter((x) => {
          let findItem = arrSelect.find((y) => x == y);

          return x != findItem;
        });
      }
    },
    clearFilter() {
      this.filter = {
        statusId: 0,
        Search: "",
        batchNo: "",
        CreateDate: "",
        brandID: [],
        ChannelId: [],
        ShppingId: [],
        PaymentTimeId: [],
        Skip: 1,
        Take: 10,
      };
      this.itemsSelected = [];
      // this.filter.ChannelId = this.sellerIdAll;
      // this.filter.ShppingId = this.shippingIdAll;
      this.isModal = false;

      this.getListByType();
      this.getBatchCount();
      // this.getBatchStatusList();
    },
    goToCreateBatch() {
      this.$router.push("/batch/create-batch");
    },
    async exportBatch() {
      this.$refs.modalLoading.show();
      this.axios
        .post(
          `${this.$baseUrl}/Batch/ExportBatchListExcel`,
          { BatchId: this.itemsSelected },
          { responseType: "blob" }
        )
        .then((data) => {
          var fileURL = window.URL.createObjectURL(new Blob([data]));
          var fileLink = document.createElement("a");
          var dateExcel = this.$moment().format("DDMMYYYYhhmmss");
          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            `export-batch` + dateExcel + `.xlsx`
          );
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$refs.modalLoading.hide();
        });
    },
    async exportOrder() {
      this.$refs.modalLoading.show();
      this.axios
        .post(
          `${this.$baseUrl}/Batch/ExportOrderListExcel`,
          { OrderId: this.itemsSelected },
          { responseType: "blob" }
        )
        .then((data) => {
          var fileURL = window.URL.createObjectURL(new Blob([data]));
          var fileLink = document.createElement("a");
          var dateExcel = this.$moment().format("DDMMYYYYhhmmss");
          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            `export-order` + dateExcel + `.xlsx`
          );
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$refs.modalLoading.hide();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.GWP {
  background-color: #e3e2f2;
  color: #8078c6;
}
.span-tooltip {
  font-weight: 100;
  font-size: 14px;
}
.date-cb {
  width: 120px;
}
.date-text {
  width: 120px;
}
.stock-text {
  min-width: 80px;
}
.price-text {
  white-space: nowrap;
}
.picture-text {
  min-width: 50px;
}
.pictureUrl-square-box {
  margin: auto;
  width: 50%;
  padding-top: 50%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.input-container {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
}
.input-container.error {
  border-color: red !important;
}
.loading-page {
  height: calc(100vh - 300px);
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .nav-pills .nav-link.active {
  background-color: #d1d0e6;
  color: #4f5d73;
}
</style>
